var variables = {
    doc: document,
    win: window,
    name: "jCube",
    version: "1.1.0",

    arr: [],
    filter: [].filter,
    slice: [].slice,
    concat: [].concat,
    map: [].map,
    push: [].push,
    some: [].some,
    indexOf: [].indexOf,

    class2type: {},
    support: {},
    defaultDisplay: {},

    numericProps: {
        animationIterationCount: true,
        columnCount: true,
        flexGrow: true,
        flexShrink: true,
        fontWeight: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        widows: true,
        zIndex: true
    },

    idRe: /^#[\w-]*$/,
    classRe: /^\.[\w-]*$/,
    htmlRe: /<.+>/,
    tagRe: /^\w+$/,
    dataAttributeRe: /^data-(.+)/,
    splitValuesRe: /\S+/g,
    cssVariableRe: /^--/,

    fragmentRe: /^\s*<(\w+)[^>]*>/,
    singleTagRe: /^\s*<(\w+)\s*\/?>(?:<\/\1>)?\s*$/,

    scriptTypeRe: /^$|^module$|\/(?:java|ecma)script/i,
    HTMLCDATARe: /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

    eventsNamespace: '__CubeEvents',
    eventsNamespacesSeparator: '.',
    eventsFocus: {
        focus: 'focusin',
        blur: 'focusout'
    },
    eventsHover: {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout'
    },
    eventsMouseRe: /^(?:mouse|pointer|contextmenu|drag|drop|click|dblclick)/i
};

variables.div = variables.doc.createElement('div');

variables.toString = variables.class2type.toString;
variables.hasOwn = variables.class2type.hasOwnProperty;

module.exports = variables;